import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { createTypeCertificate, editTypeCertificate,
seeListTypesCertificates, deleteTypeCertificate } from '../../actions/certificationActions'
import { Translate } from '../../../language';
import inMemoryJWT from '../../../auth/inMemoryJwt';

const TypeCertificateAdmin = ({ createTypeCertificate, history, editTypeCertificate, listTypesCertifications, isLoadingListTypesCertificates, deleteTypeCertificate, seeListTypesCertificates }) => {

    useEffect(() => {
        if(!(inMemoryJWT.getToken())){
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            seeListTypesCertificates()
        })
        
    },[])
    
    const [isEdit, setIsEdit] = useState(false)
    const [idEdit, setIdEdit] = useState('')
    const [indexEdit, setIndexEdit] = useState('')
    const [type, setType] = useState('')
    const [nameTypeCertificate, setNameTypeCertificate] = useState('')
    const [forConcept, setForConcept] = useState('')
    const [error, setError] = useState({})
    const [isValidate, setValidate] = useState(false)

    useEffect(() => {
        if (forConcept !== '' && type !== '' && nameTypeCertificate !== '') {
            setValidate(true)
        }
    }, [forConcept])
    const isEmpty = (e) => {
        if (forConcept !== '' && type !== '' && nameTypeCertificate !== '') {
            setValidate(true)
        }
        const { name, placeholder, value } = e.target;
        if (value.length === 0) {
            if (forConcept !== '' && type !== '' && name !== '') {
                setValidate(true)
            }
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }
        if (value.length !== 0) {

            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));

            if (forConcept !== '' && type !== '' && name !== '') {
                setValidate(true)
            }
        }

    }

    const isFocused = (e) => {
        const { name } = e.target;
        if (forConcept !== '' && type !== '' && name !== '') {
            setValidate(true)
        }
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }
    const handleSelectConcept = (e) => {
        var { value } = e.target;
        setForConcept(value)
        if (forConcept !== '' && type !== '' && nameTypeCertificate !== '') {
            setValidate(true)
        }
    }

    return (
        <div className="container-mark-type-admin">
            <div className="new-edit-type-mark-container-admin">
                <div className='title-admin'>{`${isEdit ? 'Editar' : 'Nuevo'} tipo de certificado`}</div>
                <div className="container-inputs-new-mark">
                    <div className="text-input-admin">
                        {'Tipo de certificado:'}
                    </div>
                    <input className='inputs-admin'
                        name="type"
                        type="text"
                        value={type}
                        onBlur={e => isEmpty(e)}
                        onKeyUp={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onChange={(e) => {
                            setType(e.target.value.trimStart())
                            if (forConcept !== '' && type !== '' && nameTypeCertificate !== '') {
                                setValidate(true)
                            }
                        }}
                        autoComplete="off">
                    </input>
                    <div className="text-error text-error-admin">{error.type}</div>
                    <div className="text-input-admin">
                        {'Nombre de la clase de certificados:'}
                    </div>
                    <input className='inputs-admin'
                        name="nameTypeCertificate"
                        type="text"
                        value={nameTypeCertificate}
                        onKeyUp={e => isEmpty(e)}
                        onBlur={e => isEmpty(e)}
                        onChange={(e) => {
                            setNameTypeCertificate(e.target.value.trimStart())
                            if (forConcept !== '' && type !== '' && nameTypeCertificate !== '') {
                                setValidate(true)
                            }
                        }}
                        autoComplete="off">
                    </input>
                    <div className="text-error text-error-admin">{error.nameTypeCertificate}</div>
                    <div className="text-input-admin">
                        {'Concepto de certificado:'}
                    </div>
                    <select value={forConcept} className='inputs-admin' name="forConcept" id="forConcept" onChange={(e) => {
                        handleSelectConcept(e)
                        isEmpty(e)
                    }}>
                        <option value="" selected disabled hidden>Selección</option>
                        <option value='professional_auth'>professional_auth</option>
                        <option value='user_auth'>user_auth</option>
                        <option value='mark_auth'>mark_auth</option>
                    </select>
                    {isEdit ?
                        <div className="content-buttom-create-admin">
                            <button className={`btns-admin btns-admin-inactive`} onClick={() => {
                                setNameTypeCertificate('')
                                setForConcept('')
                                setType('')
                                setIdEdit('')
                                setIndexEdit('')
                                setIsEdit(false)
                            }}>
                                {Translate('cancel', 'es')}
                            </button>
                            <div className="ml-1 mr-1"></div>
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => {
                                    editTypeCertificate({ codeType: type.trim(), name: nameTypeCertificate.trim(), forConcept: forConcept, id: idEdit }, indexEdit)
                                    setNameTypeCertificate('')
                                    setForConcept('')
                                    setType('')
                                    setIdEdit('')
                                    setIndexEdit('')
                                    setIsEdit(false)
                                }}>
                                {Translate('edit', 'es')}
                            </button>
                        </div>

                        :
                        <div className="content-buttom-create-admin">
                            <button disabled={isValidate ? '' : 'disabled'}
                                className={`btns-admin btn-create-edit ${isValidate ? '' : 'btns-admin-inactive'}`} onClick={() => { createTypeCertificate({ codeType: type.trim(), name: nameTypeCertificate.trim(), forConcept: forConcept }, history) }}>
                                {Translate('create', 'es')}
                            </button>
                        </div>
                    }
                </div>
            </div>
            <div className="see-all-mark-type-admin">
                <div className='title-admin-list'>Certificados existentes</div>
                <div className='wrapper-2 column-gap row-gap mt-3'>
                    {isLoadingListTypesCertificates ? <div>Cargando...</div> :
                        listTypesCertifications.map((classCertificate, index) => (
                            <div key={classCertificate._id} className="card-admin">
                                <div className="tittle-card-admin">{classCertificate.codeType}</div>
                                <div className="text-content-card">{classCertificate.name}</div>
                                <div className="column centerContent">
                                    <div className="btns-admin ml-1 mr-1" onClick={() => {
                                        setNameTypeCertificate(classCertificate.name)
                                        setForConcept(classCertificate.forConcept)
                                        setType(classCertificate.codeType)
                                        setIdEdit(classCertificate._id)
                                        setIndexEdit(index)
                                        setIsEdit(true)
                                    }}>Editar</div>
                                    <div className="btns-admin btns-admin-red" onClick={() => { deleteTypeCertificate(classCertificate._id, index) }}>Eliminar</div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        isLoadingListTypesCertificates: state.certificationAdmin.isLoadingListTypesCertificates,
        listTypesCertifications: state.certificationAdmin.listTypesCertifications
    }
}


export default connect(mapStateToProps, { createTypeCertificate, editTypeCertificate, seeListTypesCertificates, deleteTypeCertificate })(TypeCertificateAdmin)